import { API_URL, ANGKOR_EN_API_URL } from "../../constants/app";
import { headersFormDataToken, headersJsonToken, headersToken } from "./requestHeaders";
import { format } from "date-fns";
import CryptoJS from "crypto-js";

export async function getTouristNationalities(payload) {
  let res = await fetch(`${API_URL}/tourist-by-nationality/list`, {
    method: "POST",
    headers: headersJsonToken(),
    body: JSON.stringify(payload),
  })
    .then((res) => res.json())
    .then((data) => {
      let modifiedData = [];
      data.body.data.forEach((data, i) => {
        const [year, month, day] = data.date?.split("-");
        modifiedData.push({
          n: i + 1,
          id: data.id,
          code: data.code,
          date: data.date ? format(new Date(data.date), "dd-MMM-yyyy") : "",
          dateFormat: data.date ? format(new Date(data.date), "MMM yyyy") : "",
          dateExcel: data.date ? new Date(year, month - 1, day) : "", // format excel
          nationalityId: data.nationalityId,
          nationalityName: data.nationalityName,
          underAge12: data.underAge12,
          age12To25: data.age12To25,
          age26To59: data.age26To59,
          age60Up: data.age60Up,
          totalAge: data.totalAge,
          female: data.female,
          male: data.male,
          totalGender: data.totalGender,
          status: 1,
        });
      });
      return modifiedData;
    });

  return res;
}
export async function addTouristNationality(payload) {
  let res = await fetch(`${API_URL}/tourist-by-nationality/add`, {
    method: "POST",
    headers: headersJsonToken(),
    body: JSON.stringify(payload),
  })
    .then((res) => res.json())
    .then((data) => {
      return data;
    });
  return res;
}
export async function deleteTouristNationality(id) {
  let res = await fetch(`${API_URL}/tourist-by-nationality/delete/${id}`, {
    method: "POST",
    headers: headersToken(),
  })
    .then((res) => res.json())
    .then((data) => {
      return data;
    });
  return res;
}

export async function importExcelTouristNationality(formData) {
  let res = await fetch(`${API_URL}/tourist-by-nationality/import-excel`, {
    method: "POST",
    headers: headersFormDataToken(),
    body: formData,
  })
    .then((res) => res.json())
    .then((data) => {
      let modifiedData = [];
      let body = [];
      let dataTmp = [];

      if (data.body.status) {
        data.body.data.forEach((data, i) => {
          dataTmp.push({
            id: i + 1,
            n: i + 1,
            code: data.code,
            dateFormat: data.date ? format(new Date(data.date), "MMM yyyy") : "",
            date: data.date ? format(new Date(data.date), "dd-MMM-yyyy") : "",
            nationalityId: data.nationalityId,
            nationalityName: data.nationalityName,
            underAge12: data.underAge12,
            age12To25: data.age12To25,
            age26To59: data.age26To59,
            age60Up: data.age60Up,
            totalAge: data.totalAge,
            female: data.female,
            male: data.male,
            totalGender: data.totalGender,
          });
        });
        body = {
          data: dataTmp,
          message: data.body.message,
          status: data.body.status,
        };
      } else {
        body = {
          message: data.body.message,
          status: data.body.status,
        };
      }

      modifiedData = { body: body };

      return modifiedData;
    });
  return res;
}

export async function getRetrieveTouristNationalities(payload) {
  let res = await fetch(`${ANGKOR_EN_API_URL}/nationality?start_date=${payload.dateFrom}&end_date=${payload.dateTo}`, {
    method: "GET",
  })
    .then((res) => res.json())
    .then((data) => {
      let modifiedData = [];
      let body = [];
      const date = payload.dateFrom;
      data.country_summary?.forEach((val, i) => {
        body.push({
          id: i + 1,
          n: i + 1,
          code: CryptoJS.MD5(Date.now().toString() + (i + 1)).toString(),
          date: date,
          dateFormat: date ? format(new Date(date), "MMM yyyy") : "",  // format excel
          nationalityName: val._id.nationality,
          underAge12: 0,
          age12To25: val.Teenager,
          age26To59: val.Adult,
          age60Up: val.Pensioner,
          totalAge: 0,
          female: 0,
          male: 0,
          totalGender: 0,
          status: 0,
        });
      });
      modifiedData = {
        body: body,
        status: data.status,
        message: data.message,
      };
      return modifiedData;
    });
  return res;
}
